import React, { useEffect, useState } from "react";
import { api } from "../../lib/auth";

export const GoLiveStatus = ({ summary }) => {
  const done = summary.templates_approved === summary.templates_total;
  return (
    <div className={`rounded border p-4 text-sm ${done ? "border-emerald-200 bg-emerald-50" : "border-amber-200 bg-amber-50"}`}
      data-testid="ops-email-go-live">
      <div className="font-semibold text-slate-900" data-testid="ops-email-approved-count">
        Templates approved: {summary.templates_approved} of {summary.templates_total}
      </div>
      <p className="text-slate-700 mt-1">
        {done
          ? summary.sending_enabled
            ? "All templates are approved and sending is on — real emails are going out."
            : "All templates are approved. Production sending can now be switched on."
          : "Unapproved templates are held and never sent. Approve every template in the Templates tab before go-live."}
      </p>
    </div>
  );
};

export const UnsubscribeReasons = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/btc_email/unsubscribe-reasons").then(({ data: d }) => setData(d)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <section className="space-y-2" data-testid="ops-email-unsub-reasons">
      <h2 className="text-sm font-semibold text-slate-800">Unsubscribe reasons ({data.total})</h2>
      <div className="flex flex-wrap gap-2 text-sm">
        {Object.entries(data.labels).map(([k, label]) => (
          <span key={k} className="px-3 py-1 rounded bg-white border" data-testid={`ops-email-unsub-reason-${k}`}>
            {label}: {data.counts[k] || 0}
          </span>
        ))}
      </div>
      {data.recent_notes.length > 0 && (
        <ul className="text-xs text-slate-600 space-y-1 border rounded bg-white p-3" data-testid="ops-email-unsub-notes">
          {data.recent_notes.map((n, i) => <li key={i}>“{n.note}”</li>)}
        </ul>
      )}
    </section>
  );
};
